<div class="ui-g">
  <div class="ui-g-12">
    <p-table
      #dt
      [value]="delayFailures"
      [loading]="loading"
      [resizableColumns]="true"
      [responsive]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn>Registration</th>
          <th pResizableColumn>Delay/Failure Date</th>
          <th pResizableColumn>Delay/Failure Reason</th>
          <th pResizableColumn>Added By</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <div>{{ item.vrm }}</div>
          </td>
          <td>
            <div>{{ item.addedDate | datex : "ddd DD MMM 'YY HH:mm" }}</div>
          </td>
          <td>
            <div>{{ item.delayFailureCategory?.category }}</div>
          </td>
          <td>
            <div>{{ item.addedByUserName }}</div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- DATATABLES DEPRECATED --
    <p-dataTabl #dt [value]="delayFailures" [loading]="loading" [resizableColumns]="true" [responsive]="true">

      <p-column field="vrm" header="Registration" [style]="{'width': '10%'}">
        <ng-template let-item="rowData" pTemplate="body">
          <div>{{item.vrm}}</div>
        </ng-template>
      </p-column>

      <p-column field="addedDate" header="Delay/Failure Date" [style]="{'width': '10%'}">
        <ng-template let-item="rowData" pTemplate="body">
          <div>{{item.addedDate | datex: 'ddd DD MMM \'YY HH:mm'}}</div>
        </ng-template>
      </p-column>

      <p-column field="" header="Delay/Failure Reason" [style]="{'width': '70%'}">
        <ng-template let-item="rowData" pTemplate="body">
          <div>{{item.delayFailureCategory?.category}}</div>
        </ng-template>
      </p-column>

      <p-column field="addedByUserName" header="Added By" [style]="{'width': '10%'}">
        <ng-template let-item="rowData" pTemplate="body">
          <div>{{item.addedByUserName}}</div>
        </ng-template>
      </p-column>

    </p-dataTable>

    --->
  </div>
</div>
